/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionStatus } from '../../../models/SubmissionStatus';
import Minicard from '../../common/Minicard';
import SignIcon from '../../icons/SignIcon';

/**
 * Submission preview top sidebar fixed cards for extra large screens.
 */
export default function SubmissionPreviewFixedCards({ submission, previewObject, loadSignature, loadSubmissionFile }) {
  const { t } = useTranslation();

  const component = (
    <>
      {submission?.status === SubmissionStatus.READY_TO_SEND.id && (
        <Minicard
          key="signature"
          title={t('submission.signatures')}
          icon={<SignIcon />}
          isActive={previewObject?.id === 'signature'}
          onClick={loadSignature}
          aria-controls="filePreview"
          tabIndex="0"
        />
      )}

      <Minicard
        key="submission"
        title={t('submission.file')}
        icon={<PictureAsPdfIcon fontSize="small" />}
        isActive={previewObject?.id === 'submission'}
        onClick={loadSubmissionFile}
        aria-controls="filePreview"
      />
    </>
  );

  return useMemo(() => component, [submission?.status, previewObject, loadSignature, loadSubmissionFile]);
}
